<template>
  <v-card class="hc__rounded-card">
    <v-list v-for="(question, i) in questions" :key="i"> 
      <v-list-tile
        :key="i"
        :to="`${question.url}`"
        class="comment-list"
      >
        <v-list-tile-content>
          <div class="color-question-name">
            {{ question.name }}
          </div>
        </v-list-tile-content>

        <v-list-tile-action>
          <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/chevron-right.svg" class="chevron-right" alt="">
        </v-list-tile-action>
      </v-list-tile>
      
      <v-divider></v-divider>
    </v-list>
  </v-card>
</template>
<script>
export default {
  props: {
    questions: { type: Array, default: () => [] }
  }
}
</script>
<style lang="css">
.comment-list > .v-list__tile {
  height: 100% !important;
  padding: 10px 10px !important;
}

.color-question-name {
  color: #303030
}
.chevron-right{
  width: 40px;
  filter: invert(85%) sepia(92%) saturate(6513%) hue-rotate(117deg) brightness(96%) contrast(88%);
}
</style>